import { ExportOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components';
import { useExportLeads } from '~/controllers/sales';
import { ExportLeadsParams } from '~/api/sales';
import ExportLeadsModal from './ExportLeadsModal';

const ExportLeadsButton = () => {
  const { t } = useTranslation('sales');
  const [open, setOpen] = useState(false);
  const exportLeadsMutation = useExportLeads();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleExport = async (dateRange: ExportLeadsParams) => {
    try {
      const blob = await exportLeadsMutation.mutateAsync(dateRange);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      const filename =
        dateRange.fromDate && dateRange.toDate
          ? `leads_export_${dateRange.fromDate}_to_${dateRange.toDate}.xlsx`
          : `leads_export_${dateRange.type}.xlsx`;

      a.download = filename;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      message.success(t('Leads exported successfully'));
    } catch (error: any) {
      console.error('Export error:', error);
      message.error(error?.message || t('Failed to export leads'));
    }
  };

  return (
    <>
      <Button
        id="exportLeadsButton"
        type="primary"
        size="middle"
        icon={<ExportOutlined />}
        onClick={handleOpen}
      >
        {t('Export Leads')}
      </Button>

      <ExportLeadsModal open={open} onClose={handleClose} onExport={handleExport} />
    </>
  );
};

export default ExportLeadsButton;
